import { useMutation } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { ValidateOfflineApIdRequest } from 'src/types/manage-suppliers/OfflineSupplierValidation';
import axiosInstance from 'src/utils/axios';

export const validateOfflineApId = async ({
  apId,
  offlineSupplierId,
  supplierClientId,
}: ValidateOfflineApIdRequest): Promise<boolean> => {
  const response = await axiosInstance.get<boolean>(api.validateOfflineApId, {
    params: {
      apId,
      ...(offlineSupplierId != null && { offlineSupplierId }),
      ...(supplierClientId != null && { supplierClientId }),
    },
  });
  return response.data;
};

const useValidateOfflineApIdMutation = () =>
  useMutation({
    mutationFn: validateOfflineApId,
  });

export default useValidateOfflineApIdMutation;
